module.exports = __webpack_public_path__ + "assets/img/list_kamo_hukidashi_text.eb5445da.svg";